module.exports = __webpack_public_path__ + "img/HLTW-credit.796dbf84.jpg";